import { createAction } from "redux-act";

export const setTaskModalVisible = createAction("SET_TASK_MODAL_VISIBLE");
export const setTaskForm = createAction("SET_TASK_FORM");
export const setTaskType = createAction("SET_TASK_TYPE");
